// extracted by mini-css-extract-plugin
export default {"component_logo":"Logo_component_logo__zvAmg","header":"Logo_header__JMkt3"};